<template>
  <div class="h-screen max-h-screen overflow-y-scroll bg-background">
    <NavigationBar />
    <MainBody />
  </div>
</template>

<script>
import NavigationBar from "./components/nav/NavigationBar.vue";
import MainBody from "./components/main/MainBody.vue";

export default {
  name: "App",
  components: {
    NavigationBar,
    MainBody,
  },
};
</script>

<style src="./assets/tailwind.css" />
